import React from "react";
import Classes from "./styles/style.module.css";
import PodiumElement from "./PodiumElement";
import { useSelector } from "react-redux";

const Podium = ({ type }) => {
  const { leaderBoardData } = useSelector(({ quiz }) => quiz);
  const users = leaderBoardData ? leaderBoardData.slice(0, 3) : [];

  if (users.length !== 0) {
    return (
      <div className={Classes.podiumContainer}>
        <div className="row w-100 align-items-end mx-auto">
          <PodiumElement user={users[2]} order={3} type={type} />
          <PodiumElement user={users[0]} order={1} type={type} />
          <PodiumElement user={users[1]} order={2} type={type} />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Podium;
